$(document).on('ready', function () {

    function initSelect2(selector, options = {}) {
        const $elements = $(selector);
        if (!$elements.length) return;

        const defaultOptions = {
            sorter: data => data.sort((a, b) => a.text.localeCompare(b.text)),
            language: {
                noResults: function () {
                    return "Нет результатов";
                }
            }
        };
        $elements.select2({ ...defaultOptions, ...options })
            .on('select2:open', function (e) {
                const $self = $(this);
                const select2Instance = $self.data('select2');
                if (select2Instance && select2Instance.dropdown) {
                    const $searchInput = select2Instance.dropdown.$element.find('.select2-search input');
                    if ($searchInput.length) {
                        $searchInput
                            .prop('focus', false)
                            .attr('placeholder', $self.data('search-placeholder'));
                    }
                }
            })
            .on('select2:select change', function (e) {
                $(e.target).data('select2').$container.addClass('selected');
            });
    }

    // Инициализация для разных групп
    initSelect2('.eva-iframe-station-item__input', {
        dropdownParent: $('.eva-iframe')
    });
    initSelect2('.airport-iframe-station-item__input', {
        dropdownParent: $('.airport-iframe')
    });
    initSelect2('.nf-tabs-form__group select', {
        width: "100%",
        dropdownCssClass: 'nf-tabs-form-select-dropdown'
    });


    preselectCity();

    $('.js_countable-control').on('click', function () {
        if (!$(this).attr('disabled')) {
            let self = $(this),
                func = self.data('func'),
                input = self.siblings('.js_countable-input'),
                count = parseInt(input.val());

            const min = input.data('min'),
                max = input.data('max');

            switch (func) {
                case 'dec':
                    if (count == max) {
                        enableButton(self);
                    }
                    count -= 1;
                    setValue(count, input);
                    if (count == min) {
                        disableButton(self);
                    }
                    break;
                case 'inc':
                    if (count == min) {
                        enableButton(self);
                    }
                    count += 1;
                    setValue(count, input);
                    if (count == max) {
                        disableButton(self);
                    }
                    break;
            }

            input.trigger('change');
        }
    })

    function setValue(count, input) {
        input.val(count);
    }

    function disableButton(btn) {
        btn.prop('disabled', true);
    }

    function enableButton(btn) {
        btn.siblings('button').prop('disabled', false);
    }

    $('.js_station_change').on('click', function () {
        let cityFrom = $('.js_city_from_id'),
            cityTo = $('.js_city_to_id');

        if (cityFrom.val() != 0 && cityTo.val() != 0) {
            $(this).attr('disabled', true);
            cityFrom.attr('data-changed', cityFrom.val())
                .val(cityTo.val())
                .trigger('change');
        }
    })

    $('.nf-tabs-control__item').on('click', function () {
        let self = $(this),
            id = self.data('id');
        if (!self.hasClass('is-active')) {
            self.addClass('is-active').siblings('.is-active').removeClass('is-active');
            $('.nf-tabs-item[data-id="' + id + '"]').show().siblings('.nf-tabs-item').hide();
            $('.nf-tabs-item-title[data-id="' + id + '"]').addClass('is-active').siblings('.is-active').removeClass('is-active');
        }
    })
    $('.js_test').on('click', function () {
        $('.nf-tabs-form__row--status').addClass('is-show');
    })
    $('.nf-tabs-form__row--status').on('click', function () {
        $(this).removeClass('is-show');
    })
    $('.nf-tabs-item-title').on('click', function () {
        let self = $(this),
            id = self.data('id');
        if (!self.hasClass('is-active')) {
            self.addClass('is-active').siblings('.is-active').removeClass('is-active');
            $('.nf-tabs-item[data-id="' + id + '"]').slideDown().siblings('.nf-tabs-item').slideUp();
            $('.nf-tabs-control__item[data-id="' + id + '"]').addClass('is-active').siblings('.is-active').removeClass('is-active');
        }
    })
    $('#return_flag').on('change', function () {
        let val = $(this).val();
        if (val == 1) {
            $('.js_return-ticket-date').show()
        } else {
            $('.js_return-ticket-date').hide()
        }
    })
    $('.js_custom-time').on('change', function () {
        let self = $(this);

        if (!self.is(':checked')) {
            self.closest('.nf-tabs-form__row').find('.js_time-pick').val('00:00');
        }
    })
    $('.js_time-pick').on('change', function () {
        const $timePicker = $(this);
        if ($timePicker.val()) {
            const $form = $timePicker.closest('form');
            const $customTimeCheckbox = $form.find('.js_custom-time');

            if ($customTimeCheckbox.length) {
                $customTimeCheckbox.val(1);
            }
        }
    })
    /*if ($('.nf-tabs-control__item[data-id="booking"]').length) {
        $('.nf-tabs-control__item[data-id="booking"]').trigger('click');
    }*/

    function preselectCity() {
        if (getUrlParameter('from_id') && getUrlParameter('to_id')) {
            $('.js_city_from_id').attr('data-preselect', getUrlParameter('to_id'))
                .val(getUrlParameter('from_id'))
                .trigger('change');
        }
    }

    function getUrlParameter(sParam) {
        var sPageURL = window.location.search.substring(1),
            sURLVariables = sPageURL.split('&'),
            sParameterName,
            i;

        for (i = 0; i < sURLVariables.length; i++) {
            sParameterName = sURLVariables[i].split('=');

            if (sParameterName[0] === sParam) {
                return sParameterName[1] === undefined ? true : decodeURIComponent(sParameterName[1]);
            }
        }
        return false;
    }

});